'use client';

import React from 'react';
import { Button } from 'src/components';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/pro-solid-svg-icons';
import { useAnalytics } from 'src/hooks/analytics';
import { ANALYTICS_LOCATION } from 'src/hooks/filters/constants';

const AnalyticsAspButton = () => {
  const { selectedCodeSet = [] } = useAnalytics(ANALYTICS_LOCATION.ASP) || {};

  const { closeAllButCurrent } = useDrawer();

  const handleToggleAspDrawer = () => {
    closeAllButCurrent('asp-drawer');
    // Logic to open ASP configuration drawer goes here
  };

  const hasSelectedCodeSet = selectedCodeSet && selectedCodeSet.length > 0;
  return (
    <Button
      variant="outlined"
      color="neutral"
      className="!px-3 !py-1.5 rounded-full text-sm font-normal !h-auto cursor-pointer 
        flex items-center whitespace-nowrap w-full  disabled:cursor-not-allowed disabled:bg-neutral-100"
      onClick={handleToggleAspDrawer}
      disabled={!hasSelectedCodeSet}
    >
      <Icon icon={faCog} className="mr-1" />
      Configure ASP
    </Button>
  );
};

export default AnalyticsAspButton;
